var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Col, MultiSelection, Row, Select, TextField, Timepicker, } from '@folio/stripes/components';
import React from 'react';
import { Field, useField } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { SchedulingFrequency } from '../../types';
import useLocaleWeekdays from '../../hooks/useLocaleWeekdays';
export default function SchedulingSection() {
    var frequencyValue = useField('scheduling.frequency', {
        subscription: { value: true },
    }).input.value;
    var intl = useIntl();
    var localeWeekdays = useLocaleWeekdays(intl);
    var manualFrequencyComponent = (React.createElement(Col, { xs: 12, md: 6 },
        React.createElement(Field, { name: "scheduling.frequency", defaultValue: SchedulingFrequency.Manual }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.scheduling.frequency" }), dataOptions: [
                {
                    label: intl.formatMessage({
                        id: 'ui-plugin-bursar-export.bursarExports.scheduling.frequency.manual',
                    }),
                    value: SchedulingFrequency.Manual,
                },
                {
                    label: intl.formatMessage({
                        id: 'ui-plugin-bursar-export.bursarExports.scheduling.frequency.hours',
                    }),
                    value: SchedulingFrequency.Hours,
                },
                {
                    label: intl.formatMessage({
                        id: 'ui-plugin-bursar-export.bursarExports.scheduling.frequency.days',
                    }),
                    value: SchedulingFrequency.Days,
                },
                {
                    label: intl.formatMessage({
                        id: 'ui-plugin-bursar-export.bursarExports.scheduling.frequency.weeks',
                    }),
                    value: SchedulingFrequency.Weeks,
                },
            ] }))); })));
    var hoursDaysWeeksFrequencyComponent = (React.createElement(Col, { xs: 12, md: 6 },
        React.createElement(Field, { name: "scheduling.interval", validate: function (value) { return Number.isNaN(+value) || +value <= 0 ? React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.scheduler.interval.error" }) : undefined; } }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.scheduling.interval.".concat(frequencyValue) }), min: 1 }))); })));
    var daysWeeksFrequencyComponent = (React.createElement(Col, { xs: 12, md: 6 },
        React.createElement(Field, { name: "scheduling.time" }, function (fieldProps) { return (React.createElement(Timepicker, __assign({}, fieldProps, { required: true, label: intl.formatMessage({
                id: 'ui-plugin-bursar-export.bursarExports.scheduling.time',
            }) }))); })));
    var weeksFrequencyComponent = (React.createElement(Col, { xs: 12, md: 6 },
        React.createElement(Field, { name: "scheduling.weekdays" }, function (fieldProps) { return (React.createElement(MultiSelection, __assign({}, fieldProps, { required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.scheduling.weekdays" }), dataOptions: localeWeekdays.map(function (weekday) { return ({
                label: weekday.long,
                value: weekday.weekday,
            }); }) }))); })));
    return (React.createElement(Row, null,
        manualFrequencyComponent,
        [SchedulingFrequency.Hours, SchedulingFrequency.Days, SchedulingFrequency.Weeks].includes(frequencyValue) && hoursDaysWeeksFrequencyComponent,
        [SchedulingFrequency.Days, SchedulingFrequency.Weeks].includes(frequencyValue) && daysWeeksFrequencyComponent,
        frequencyValue === SchedulingFrequency.Weeks && weeksFrequencyComponent));
}
